module.exports = __webpack_public_path__ + "f3ba9a19d0531f25c3bf48742ef3d708.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-pink-s.png
// module id = 1993
// module chunks = 0